<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
export default {
	props: {
		HuanqViewDetails: {
			type: Boolean,
			default: false
		},
		interface:0
	},
	watch: {
		HuanqViewDetails: function(indexVal, oldVal) {
			if (indexVal) {
			}
		}
	},
	data() {
		return {};
	},
	mounted() {},
	created() {},
	methods: {
		closediagViewDetails() {
			this.$emit('closediagViewDetails', false);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
